import { type Meta } from '../types/docs';

export const ONBOARDING_ANALYTICS_CATEGORIES = ['onboarding', 'agent_onboarding'] as const;

export type OnboardingAnalyticsCategory = (typeof ONBOARDING_ANALYTICS_CATEGORIES)[number];

export type WithOnboardingAnalyticsCategory<T extends Record<string, unknown> = Record<string, unknown>> = T & {
  category: OnboardingAnalyticsCategory;
};

type MetaParam = NonNullable<Meta['params']>[number];

export const ONBOARDING_ANALYTICS_CATEGORY_META_PARAM = {
  description: 'Which onboarding flow sent this event',
  name: 'category',
  required: true,
  type: 'enum',
  values: [...ONBOARDING_ANALYTICS_CATEGORIES],
} satisfies MetaParam;
